<template>
    <div class="box">
        <div :class="showTop ? 'heads ' : 'heads heads1'">
            <img v-if="showTop" src="/subject/searchReport/logo.png" alt="" />
            <img v-else src="/subject/opportunity/logos.png" alt="" />
            <div class="headlist">
                <el-menu v-if="windowWidth >= 500" :default-active="activeIndex"
                    :class="showTop ? 'el-menu-demo' : 'heads1'" mode="horizontal" @select="handleSelect"
                    text-color="#fff" style="border: 0" active-text-color="#f00000">
                    <el-menu-item index="1">首页</el-menu-item>
                    <el-menu-item index="2">发布会直播</el-menu-item>
                    <el-menu-item index="3">专家团队介绍</el-menu-item>
                    <el-menu-item index="4">会议议程</el-menu-item>
                    <el-menu-item index="5">投研报告</el-menu-item>

                    <el-menu-item index="6">往届回顾</el-menu-item>
                    <el-menu-item index="7">支持媒体</el-menu-item>
                    <el-menu-item index="8">关注我们</el-menu-item>

                </el-menu>
                <!-- <div v-for="(item, index) in headlist" :key="index"  class="head-name">
          <div @click.stop="selecttab(index)">{{item}}</div>
          <div  :class="cutter==index?'head-line':'' "></div>
        </div> -->
            </div>
        </div>
        <div class="float" v-if="showFloat" @mouseenter="showClose1" @mouseleave="closeClose">
            <img class="float-img" @click="live800" src="/subject/opportunity/float.png" alt="" />
            <img class="close" v-show="!showClose" src="/subject/searchReport/close.png" alt="" />
            <img @click.stop="closeFloat" v-show="showClose" class="close" src="/subject/searchReport/closes.png"
                alt="" />
        </div>
        <div class="float1" @click="toTop" v-show="showTop" @mouseenter="showTops1" @mouseleave="closeTops">
            <img src="/subject/searchReport/tops.png" v-show="showTops" alt="" />

            <img src="/subject/searchReport/top.png" v-show="!showTops" alt="" />


        </div>
        <div class="bannerBox">
            <img class="banner" src="/subject/opportunity/topbg.png" alt="" />
            <div class="bannerBox-area">
                <div class="bannerBox-top">
                    <span>中国 · 香港</span>
                    <img src="/subject/opportunity/tips.png" alt="" />
                </div>
                <div class="bannerBox-tit">
                    —— 2026 / 01 / 14 ——
                </div>
            </div>

        </div>
        <div class="content">
            <div class="part1">
                <div class="part1-box" ref="targetElement1">
                    <img class="part1-top " src="/subject/opportunity/title.png" alt="">
                    <div class="part1-cont">

                        <video v-if="ckplayerObject.live && playIndex == 0" ref="videoPlayer" id="videoPlayer" style="  width: 1010px;
                height: 586px;" class="video-js" muted></video>
                        <video v-else class="part1-video" autoplay="autoplay" muted :src="playUrl" controls></video>
                        <div class="part1-right">
                            <p>精彩视频</p>
                            <div :class="index == 2 ? 'video-box videobox1' : index == 3 ? 'video-box videobox2' : 'video-box'"
                                v-for="(item, index) in playlist" :key="index" @click="videoPlay(item, index)">
                                <div class="video-tit">
                                    <span class="tits">{{ item.title }}</span><br />
                                    <span class="tits1">{{ item.title1 }}</span>
                                </div>
                                <img v-if="index == playIndex" :src="item.img" alt="">
                                <img v-else :src="item.imgs" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="part1-box part1-box1" ref="targetElement2">
                    <img class="part1-top" style="margin-bottom: 0;" src="/subject/opportunity/title2.png" alt="">
                    <label class="part1-label" for="">分析师的观点仅代表分析师个人立场，不代表本公司立场，投资有风险，入市需谨慎！</label>
                    <div class="p2-flex">
                        <div class="p2-flexs" @mouseenter="showCont" @mouseleave="closeCont">
                            <div class="p2-box icon1" v-if="showContent1">
                                <div class="conts">
                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">顺势交易不与市场对做</span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        台湾知名学府毕业，具备多年金融投资经验，自16年开始成为专职交易员，主要操作贵金属黄金、美国道琼斯指数及数字货币，热衷于区块链技术应用及数字货币领域分析，并且擅长技术分析应用，K线形态、技术指标、斐波那契、波浪理论等，运用独特的技术分析方式去推算市场惯性及时间循环，并看好未来区块链应用发展落地，去中心化金融崛起，并在数字货币领域靠着精湛的分析技术创造超过200%的做人成绩。
                                    </div>
                                </div>


                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon.png" alt="" />

                        </div>
                        <div class="p2-flexs" @mouseenter="showCont1" @mouseleave="closeCont1">
                            <div class="p2-box icon2"  v-if="showContent2">
                                <div class="conts">

                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">决不要因为失去耐心而退出市场，也决不要因为迫不及待而进入市场
                                    </span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        计算机科学硕士学位，曾在国外知名投资银行担任对冲经理人，特别专长于股票、期货对冲以及选择权价差交易。擅长以演算法找出选择权定价高估或低估的产品进行无风险套利。推算出风险平衡最佳化的股票与选择权投资组合，短线赚取价差获利，长线赚取大行情。致力于打造稳定赚取被动收入的价差组合，与出现行情时赚取高报酬低风险的投资组合。专长操作的金融产品为美股、期货、贵金属、指数选择权。
                                    </div>
                                </div>
                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon1.png" alt="" />

                        </div>
                        <div class="p2-flexs" @mouseenter="showCont2" @mouseleave="closeCont2">
                            <div class="p2-box icon3" v-if="showContent3">
                                <div class="conts">

                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">别人贪婪我恐惧，别人恐惧我贪婪 </span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        澳洲墨尔本大学财经硕士，投资经验十年，取得CFA美国财务分析师...等多项国内外金融证照；曾在私人投资基金任职宏观经济研究员，股指原物料皆有广泛涉猎。擅长从政策与数据变化中寻找投资机会，辅以成交量、均线与RSI...等指标综合创造进出场点位，有一套独特的趋势解读看法。
                                    </div>
                                </div>
                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon2.png" alt="" />

                        </div>
                        <div class="p2-flexs" @mouseenter="showCont3" @mouseleave="closeCont3">
                            <div class="p2-box icon4" v-if="showContent4">
                                <div class="conts">

                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">时间就是金钱，进场时机永远比你的目标价位重要
                                    </span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        美国名校毕业。研究黄金和股指多年，具有长期指导实战交易的经历，擅长宏观经济和货币政策的研究，央行官员讲话和报告的分析解读，以此来洞悉基本面的走向。技术分析层面擅长主力區間，市场主力进出场时机判断有丰富经验。价格技术分析的优势在于筹码面交易的研究；对15分钟、1小时、4小时和日线之间的切换研究有深刻体会。同时在日内开盘，收盘价，主力进场位判断和止损风控方面有多年浸淫。
                                    </div>
                                </div>
                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon3.png" alt="" />

                        </div>
                    </div>
                </div> -->
                <div class="part1-box part1-box1" ref="targetElement2">
                    <img class="part1-top" style="margin-bottom: 0;" src="/subject/opportunity/title2.png" alt="">
                    <label class="part1-label" for="">分析师的观点仅代表分析师个人立场，不代表本公司立场，投资有风险，入市需谨慎！</label>
                    <div class="p2-flex">
                        <div class="p2-flexs" @mouseenter="showContentindex(0)" @mouseleave="closeContent(0)">
                            <div class="p2-box icon1" v-if="showContent1">
                                <div class="conts">
                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">顺势交易不与市场对做</span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        台湾知名学府毕业，具备多年金融投资经验，自16年开始成为专职交易员，主要操作贵金属黄金、美国道琼斯指数，热衷于区块链技术应用领域分析，并且擅长技术分析应用，K线形态、技术指标、斐波那契、波浪理论等，运用独特的技术分析方式去推算市场惯性及时间循环，并看好未来区块链应用发展落地，去中心化金融崛起，靠着精湛的分析技术创造超过200%的做人成绩。
                                    </div>
                                </div>
                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon.png" alt="" />
                        </div>
                        <div class="p2-flexs" @mouseenter="showContentindex(1)" @mouseleave="closeContent(1)">
                            <div class="p2-box icon2" v-if="showContent2">
                                <div class="conts">
                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">决不要因为失去耐心而退出市场，也决不要因为迫不及待而进入市场
                                    </span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        计算机科学硕士学位，曾在国外知名投资银行担任对冲经理人，特别专长于股票、期货对冲以及选择权价差交易。擅长以演算法找出选择权定价高估或低估的产品进行无风险套利。推算出风险平衡最佳化的股票与选择权投资组合，短线赚取价差获利，长线赚取大行情。致力于打造稳定赚取被动收入的价差组合，与出现行情时赚取高报酬低风险的投资组合。专长操作的金融产品为美股、期货、贵金属、指数选择权。
                                    </div>
                                </div>
                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon1.png" alt="" />
                        </div>
                        <div class="p2-flexs" @mouseenter="showContentindex(2)" @mouseleave="closeContent(2)">
                            <div class="p2-box icon3" v-if="showContent3">
                                <div class="conts">
                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">别人贪婪我恐惧，别人恐惧我贪婪 </span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        澳洲墨尔本大学财经硕士，投资经验十年，取得CFA美国财务分析师...等多项国内外金融证照；曾在私人投资基金任职宏观经济研究员，股指原物料皆有广泛涉猎。擅长从政策与数据变化中寻找投资机会，辅以成交量、均线与RSI...等指标综合创造进出场点位，有一套独特的趋势解读看法。
                                    </div>
                                </div>
                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon2.png" alt="" />
                        </div>




                        <div class="p2-flexs" @mouseenter="showContentindex(3)" @mouseleave="closeContent(3)">
                            <div class="p2-box icon4" v-if="showContent4">
                                <div class="conts">
                                    <div class="tops">
                                        <img src="/subject/searchReport/pen.png" alt="" />
                                        <span>交易箴言:</span>
                                    </div>
                                    <span class="tit">时间就是金钱，进场时机永远比你的目标价位重要
                                    </span>
                                    <span class="introduce">个人简介：</span>
                                    <div class="bott">
                                        美国名校毕业。研究黄金和股指多年，具有长期指导实战交易的经历，擅长宏观经济和货币政策的研究，央行官员讲话和报告的分析解读，以此来洞悉基本面的走向。技术分析层面擅长主力區間，市场主力进出场时机判断有丰富经验。价格技术分析的优势在于筹码面交易的研究；对15分钟、1小时、4小时和日线之间的切换研究有深刻体会。同时在日内开盘，收盘价，主力进场位判断和止损风控方面有多年浸淫。
                                    </div>
                                </div>
                            </div>
                            <img v-else class="teachericon" src="/subject/opportunity/icon3.png" alt="" />
                        </div>
                
                </div>
            </div>
        </div>

        <div class="partcont1">
            <div class="part3" ref="targetElement3">
                <div class="part3-content">
                    <img class="topbg" src="/subject/opportunity/title3.png" alt="" />
                    <div class="p1_box">
                        <div class="p1-left">

                            <div class="p1-content">
                                <span class="year">2026</span>
                                <span class="date">01/14</span>
                                <span>多年投资经验</span>
                                <span>不断总结，不断实践数月精心准备</span>
                                <span>打造<span class="weight">2026年</span></span>
                                <span class="weight">极具参考价值的投资方案内容</span>
                                <span>汇集投资干货，极具实操价值</span>
                                <span class="tips">该程供参考，实际内容以会议为准</span>
                            </div>
                            <img class="p1-img1" @click="Login" src="/subject/searchReport/login.png" alt="" />
                            <img @click="live800" class="p1-img" src="/subject/searchReport/request.png" alt="" />
                            <div class="p1-content1">
                                咨询客服获取投研报告及<span>打开密码</span>
                            </div>
                        </div>
                        <div class="p1-right">
                            <div v-for="(item, index) in targelist" :class="index == 5 ? 'boxs boxs1 ' : 'boxs'"
                                :key="index">
                                <span>{{ item.time }}</span>
                                <span class="title">{{ item.title }}</span>
                                <div v-if="item.avatar" class="introduce">
                                    <img class="avatar" :src="item.avatar" alt="" />
                                    <p>
                                        <span>{{ item.teacher }}</span>
                                        <span class="name">{{ item.name }}</span>
                                        <span v-if="item.names" class="name">{{ item.names }}</span>
                                    </p>
                                </div>
                            </div>

                        </div>



                    </div>
                </div>

            </div>
            <div class="part4 " ref="targetElement4">
                <div class="part4-cont">
                    <img class="toptit" src="/subject/opportunity/title4.png" alt="" />
                    <div class="p1_box">

                        <div class="p1-right">
                            <img src="/subject/opportunity/report2.png" alt="" />
                            <img src="/subject/opportunity/cover2.png" alt="" />

                            <img src="/subject/opportunity/report1.png" alt="" />
                        </div>
                        <div class="p1-left">
                            <div class="p-content">
                                预订研报，抢投资先机
                            </div>
                            <div class="p1-content">
                                股市、期货、黄金、房地产具体投资策略一一展开内容翔实，助您实战一臂之力
                            </div>
                            <div class="p1-content2"><span>名额有限</span> 送完即止！</div>
                            <img class="p1-img1" @click="Login" src="/subject/searchReport/login.png" alt="" />
                            <img @click="live800" class="p1-img" src="/subject/searchReport/request.png" alt="" />
                            <div class="p1-content1">
                                咨询客服获取投研报告及<span>打开密码</span>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div>

        <div class="partcont">
            <div class="part6" ref="targetElement5">
                <div class="part6-content">
                    <img src="/subject/opportunity/title5.png" class="part6-tit" alt="" />
                    <div class="historyItem" v-for="(item, i) in histotylist" :key="i" @click="handleClick(item.url)">
                        <img class="historybg" :src="item.img" alt="" />
                        <div class="rightcont">
                            <div class="title">{{ item.title }}</div>
                            <div class="cont">{{ item.cont }}</div>
                            <div class="time"> <img src="/subject/opportunity/time.png" alt="" />{{ item.time }}
                            </div>
                            <span class="detail">了解详情 ></span>
                        </div>

                    </div>
                </div>

            </div>
            <div class=" part7" ref="targetElement6">
                <div class="part7-content">
                    <img src="/subject/opportunity/title6.png" class="part7-tit" alt="" />
                    <img src="/subject/opportunity/medias.png" class="media" alt="" />
                </div>
                x
            </div>
        </div>

        <div class="part8" ref="targetElement7">
            <div class="part8-content">
                <img class="topbg" src="/subject/opportunity/title7.png" alt="">
                <div class="phoneBox">
                    <img class="phone" src="/subject/opportunity/phone.png" alt="" />


                    <div class="partRight">


                        <div class="appCode">
                            <div class="app-box">
                                <div class="codeBody">
                                    <div>MT4账户专用版本</div>
                                    <div class="codeBox">
                                        <div class="codeItem">
                                            <Qrcode :link="iosMt4DownloadUrl" :size="126" :iconSize="30" />
                                            <div>iOS</div>
                                        </div>
                                        <div class="codeItem">
                                            <Qrcode :link="androidMt4DownloadUrl" :size="126" />
                                            <div>Android</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="codeBody">
                                    <div>MT5账户专用版本</div>
                                    <div class="codeBox">
                                        <div class="codeItem">
                                            <Qrcode :link="iosMt5DownloadUrl" :size="126" />
                                            <div>iOS</div>
                                        </div>
                                        <div class="codeItem">
                                            <Qrcode :link="androidDownloadUrl" :size="126" />
                                            <div>Android</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="serveBox">
                            <div class="serveBox-title">下载官方APP，发现更多智富可能</div>
                            <div class="serveBox-item" style="margin-top: 16px">
                                <div>1、MT4版本用MT4账户，MT5版本用MT5账户，两者不互通；</div>
                            </div>
                            <div class="serveBox-item">
                                <div>
                                    2、本平台2024.8.17日之前开立的是MT4账户，之后开立的账户以开户时所选账户类型为准，
                                    如果不确定，请联系<span class="serveBox-serve" @click="live800">在线客服</span>查询。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Contactus></Contactus>
    </div>
</template>

<script>
import Contactus from "@/component/base-footer";
import { livingRoomNow } from "../../../../api/info";
import videojs from "video.js";
import Qrcode from "@/component/QrCode/index.vue";
import { mapState } from "vuex";
export default {
    name: "newReportPC",
    components: {
        Contactus,
        Qrcode,
    },
    data() {
        return {
            isVideo: '/subject/searchReport/report.mp4',
            // swiper 参数
            swiperOption: {
                slidesPerView: 1,
                // swiper图片之间的间隔
                spaceBetween: 0,
                centeredSlides: true,
                grabCursor: true,
                loop: true,
                preventClicks: true,
                //自动播放
                autoplay: {
                    delay: 4000, //延迟播放下一张图片
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                swiperData: [{ img: "" }],
            },
            swiperVideoOption: {
                slidesPerView: 1,
                // swiper图片之间的间隔
                spaceBetween: 20,
                centeredSlides: true,
                grabCursor: true,
                loop: true,
                preventClicks: true,
                //自动播放
                // autoplay: {
                //   delay: 4000, //延迟播放下一张图片
                //   stopOnLastSlide: false,
                //   disableOnInteraction: false,
                // },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            screenWidth: null,
            scroll: Number,
            timer: null,
            myPlyer: null,
            options: null,

            activeIndex: "1", //菜单选中
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            targetElements: null, //菜单距离屏幕的距离
            showFloat: true, //浮窗

            showContent1: true,
            showContent2: false,
            showContent3: false,
            showContent4: false,
            showTop: true, //回到顶部
            showTops: false,//回到顶部按钮
            showClose: false,//显示关闭按钮
            starttime: '2024-12-18 14:00',
            isShowVIdeo: false,
            curStartTime: "2024-12-18 14:00:00",
            day: "00",
            hour: "00",
            min: "00",
            second: "00",
            playUrl: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E5%90%B4%E9%BE%99%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E7%BB%88%E6%9E%81%E7%89%88.mp4',
            playIndex: 0,
            playlist: [
                {
                    title: '美联储重启降息对全球资产影响',
                    title1: '',
                    img: '/subject/opportunity/play.png',
                    imgs: '/subject/opportunity/continue.png',
                    url: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E5%90%B4%E9%BE%99%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E7%BB%88%E6%9E%81%E7%89%88.mp4'

                },
                {
                    title: '中国新质生产力爆发对冲全球贸易',
                    title1: '脱钩断链',
                    img: '/subject/opportunity/play.png',
                    imgs: '/subject/opportunity/continue.png',
                    url: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E4%B8%87%E8%89%AF%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E5%89%AA%E8%BE%91(1).mp4  '


                },
                {
                    title: '欧洲受两强夹击，欧洲央行与欧元',
                    title1: '的出路分析',
                    img: '/subject/opportunity/play.png',
                    imgs: '/subject/opportunity/continue.png',
                    url: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E9%A9%AC%E6%96%87%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E6%9C%80%E7%BB%88(1).mp4'

                },
                {
                    title: '美对等关税冲击全球化，2026年投',
                    title1: '资市场影响',
                    img: '/subject/opportunity/play.png',
                    imgs: '/subject/opportunity/continue.png',
                    url: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E6%98%8E%E6%9D%B0%E7%BB%88%E6%9E%81%E7%89%88%E6%9C%AC%E4%BD%BF%E7%94%A8(1).mp4'

                },
                {
                    title: '全球政局此消彼长对全球投资盈利',
                    title1: '的影响',
                    img: '/subject/opportunity/play.png',
                    imgs: '/subject/opportunity/continue.png',
                    url: 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E5%9C%86%E6%A1%8C%E4%BC%9A%E8%AE%AE%E5%AE%9A%E7%89%88.mp4'

                },

            ],
            histotylist: [
                {
                    img: '/subject/opportunity/cart.png',
                    title: '2025全球投资机会研究报告',
                    cont: '以“全球资产配置”为核心主线，结合中美货币政策、中国经济复苏路径与美国大选变量，深入剖析2025年全球投资热点，并通过圆桌对话与互动问答，凝聚专家共识，助力投资者把握复杂环境下的战略机遇',
                    time: '2024/12/18 14:00~16:35',
                    url: 'https://www.rlcproltd.net/#/subject/searchReport/index'
                },
                {
                    img: '/subject/opportunity/cart1.png',
                    title: '2024年全球投资机会研究报告',
                    cont: '深入探讨2024年全球宏观经济格局下的投资机遇，围绕美联储转向、地缘冲突、大宗商品走势及汇率波动，全面展望黄金、房地产等核心资产的配置策略与未来趋势',
                    time: '2024/01/10 14:00~17:00',
                    url: 'https://www.rlcproltd.net/#/subject/tg_9654/index'
                },
                {
                    img: '/subject/opportunity/cart2.png',
                    title: '2023年春夏投资机会研究报告',
                    cont: '聚焦全球宏观政策与地缘风险对资产价格的深远影响，通过美联储政策、俄乌战争及市场热点的多维解析，系统揭示了贵金属与股市的投资逻辑与布局方向',
                    time: '2023/03/24 14:00~17:30',
                    url: 'https://www.rlcproltd.net/#/subject/newReport/index'
                },
            ],
            targelist: [
                {
                    time: '14:00',
                    title: '会议开场致辞',

                },
                {
                    time: '14:05',
                    title: '美联储重启降息对全球资产影响',
                    avatar: '/subject/opportunity/avatar3.png',
                    teacher: '吴龙',
                    name: '红狮金业研究院资深分析师',
                },
                {
                    time: '14:35',
                    title: '中国新质生产力爆发对冲全球贸易脱钩断链',
                    avatar: '/subject/opportunity/avatar2.png',
                    teacher: '万良',
                    name: '红狮金业研究院资深分析师',
                },
                {
                    time: '15:05',
                    title: '欧洲受两强夹击，欧洲央行与欧元的出路分析',
                    avatar: '/subject/opportunity/avatar.png',
                    teacher: '马文',
                    name: '红狮金业研究院资深分析师',
                },
                {
                    time: '15:35',
                    title: '美对等关税冲击全球化，2026年投资市场影响',
                    avatar: '/subject/opportunity/avatar1.png',
                    teacher: '明杰',
                    name: '红狮金业研究院资深分析师',
                },
                {
                    time: '16:05',
                    title: '全球政局此消彼长对全球投资盈利的影响',
                    avatar: '/subject/opportunity/avatar4.png',
                    teacher: 'Mandy',
                    name: '财经主持人',
                    names: '嘉宾：吴龙，万良，马文，明杰'
                },
                {
                    time: '16:35',
                    title: '答疑互动环节',

                },
            ],

        };
    },

    computed: {
        ckplayerObject() {
            return this.$store.state.home.ckplayerObject;
        },
        teacherPlayBack() {
            return this.$store.state.home.teacherPlayBack;
        },
        ...mapState("common", {
            androidMt4DownloadUrl: "androidMt4DownloadUrl",
            androidDownloadUrl: "androidDownloadUrl",
            iosMt4DownloadUrl: "iosMt4DownloadUrl",
            iosMt5DownloadUrl: "iosMt5DownloadUrl",
        }),
    },
    created() {
        // 传给App.vue,展示tabbar
        this.$emit("controlShow", true);


        this.init();
    },
    beforeDestroy() {
        //在 beforeDestroy生命周期函数中销毁定时器
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        screenWidth: function (n) {
            if (n < 500) {
                this.$router.push({
                    name: "opportunityStudyWap",
                });
            }
        },

    },
    mounted() {

        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener('click', this.playVideo);
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            //屏幕尺寸变化
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };

    },
    // beforeDestroy() {
    //   this.myPlyer.dispose();
    // },
    methods: {
        init() {
            livingRoomNow({ platid: 1 }).then(res => {
                console.log('直播地址', res);
                if (res.Status == 0 && res.content.length > 0) {
                    this.$store.commit('home/set_ckplayerObject', { video: res.content[0].param.pcurl, live: true })
                    this.isVideo = res.content[0].param.pcurl;
                    this.playUrl = res.content[0].param.pcurl;
                    this.playlist[0].url = this.playUrl;
                    setTimeout(() => {
                        this.initVideo(this.isVideo);
                    }, 500)
                } else {
                    this.$store.commit('home/set_ckplayerObject', { video: '/subject/searchReport/report.mp4', live: false })
                    this.playUrl = 'https://pmnew.blob.core.windows.net/xsnews/cmsimg/%E5%90%B4%E9%BE%99%E8%80%81%E5%B8%88%E8%A7%86%E9%A2%91%E7%BB%88%E6%9E%81%E7%89%88.mp4',
                        this.playlist[0].url = this.playUrl;
                    // this.myPlyer.dispose();
                }
            }).catch(err => {
                console.log(err);
            })
        },
        // 播放视频
        videoPlay(item, index) {
            console.log(this.ckplayerObject.live);
            if (this.ckplayerObject.live && index == 0) {
                this.playIndex = 0;

                setTimeout(() => {
                    this.initVideo(item.url);
                }, 500)


            } else {

                this.playUrl = item.url;
                this.playIndex = index;
            }
        },
        handleClick(url) {
            window.open(url);
        },
        // 获取倒计时
        countTime() {
            // 获取当前时间
            let date = new Date();
            let now = date.getTime();
            // 设置截止时间
            let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
            let end = endDate.getTime();

            // 时间差
            let leftTime = end - now;
            // 定义变量 d,h,m,s保存倒计时的时间

            if (leftTime >= 0) {
                // 天
                let day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                // 三元表达式判断不满10前面加0
                this.day = day < 10 ? "0" + day : day;
                // 时
                let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                this.hour = h < 10 ? "0" + h : h;
                // 分
                let m = Math.floor((leftTime / 1000 / 60) % 60);
                this.min = m < 10 ? "0" + m : m;
                // 秒
                let s = Math.floor((leftTime / 1000) % 60);
                this.second = s < 10 ? "0" + s : s;
                // console.log(this.day, this.hour, this.min, this.second);
            } else {
                this.day = "00";
                this.hour = "00";
                this.min = "00";
                this.second = "00";
            }
            // 等于0的时候不调用
            if (
                Number(this.hour) === 0 &&
                Number(this.day) === 0 &&
                Number(this.min) === 0 &&
                Number(this.second) === 0
            ) {
                return;
            } else {
                // 递归每秒调用countTime方法，显示动态时间效果,
                setTimeout(this.countTime, 1000);
            }
        },
        getTime() {
            let times = new Date('2024-12-18 14:00:00').getTime()

            let time = new Date().getTime()
            console.log('时间·--------------------------', times, time, time >= times)
            if (time >= times) {
                this.isShowVIdeo = true
                this.init()

            } else {
                this.isShowVIdeo = false
            }
        },
        playVideo() {
            this.$refs.videoPlayer.play();

        },
        // 鼠标移入顶部按钮
        showTops1() {
            this.showTops = true
        },
        // 鼠标移除
        closeTops() {
            this.showTops = false

        },
        // 鼠标移入
        showClose1() {
            this.showClose = true
        },
        closeClose() {
            this.showClose = false

        },
        toTop() {
            document.documentElement.scrollTop = 0;
        },
        
        showContentindex(index) {
            // 重置所有卡片的显示状态
            this.showContent1 = false;
            this.showContent2 = false;
            this.showContent3 = false;
            this.showContent4 = false;

            // 根据传入的索引显示对应的卡片
            switch (index) {
                case 0:
                    this.showContent1 = true;
                    break;
                case 1:
                    this.showContent2 = true;
                    break;
                case 2:
                    this.showContent3 = true;
                    break;
                case 3:
                    this.showContent4 = true;
                    break;
                default:
                    // 默认显示第一个卡片
                    this.showContent1 = true;
            }
        },
        closeContent(index) {
           
            switch (index) {
                case 0:
                    this.showContent1 = true;
                    break;
                case 1:
                    this.showContent2 = false;
                    break;
                case 2:
                    this.showContent3 = false;
                    break;
                case 3:
                    this.showContent4 = false;
                    break;
                default:
                    // 默认显示第一个卡片
                    this.showContent1 = true;
            }
            this.showContent1=true
        },
        // 关闭弹窗
        closeFloat() {
            this.showFloat = false;
        },
        // 点击跳转到指定位置
        scrollToTarget() {
            // const targetElements = this.$refs.targetElement;
            const targetPosition = this.targetElements?this.targetElements.offsetTop - 150:0;
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },
        // 选择导航
        handleSelect(key) {
            console.log(key);
            this.$emit("getKey", key);
            sessionStorage.setItem("key", key);
            // this.getSessinKey(key);
            switch (key) {
                case "1":
                    this.activeIndex = key;

                    this.toTop()

                    break;
                case "2":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement1;

                    this.scrollToTarget();

                    break;
                case "3":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement2;

                    this.scrollToTarget();

                    break;
                case "4":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement3;

                    this.scrollToTarget();

                    break;
                case "5":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement4;

                    this.scrollToTarget();

                    break;
                case "6":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement5;

                    this.scrollToTarget();

                    break;
                case "7":
                    this.activeIndex = key;
                    this.targetElements = this.$refs.targetElement6;

                    this.scrollToTarget();

                    break;

                case "8":
                    this.activeIndex = key;

                    this.targetElements = this.$refs.targetElement7;

                    this.scrollToTarget();

                    break;
            }
        },
        selecttab(e) {
            console.log(e);
            this.cutter = e;
        },
        // 获取是否直播以及直播流


        live800() {
            window.open(this.$parent.live800UrlUc);
        },
        Login() {
            window.open("https://www.rlcvipltd.net/uc/login");
        },
        toUrl() {
            window.open("https://www.rlcproltd.net/#/subject/tg_9654/index");
        },
        toUrl1() {
            window.open("https://www.rlcproltd.net/#/subject/newReport/index");
        },
        toVIdeo() {
            window.open("https://www.rlcproltd.net/#/subject/classRoom/index");

        },
        goBank() {
            window.location.href = window.location.origin;
        },
        // 初始化videojs内容
        initVideo(nowPlayVideoUrl) {
            // 这些options属性也可直接设置在video标签上，见 muted
            this.options = {
                autoplay: true, // 设置自动播放
                controls: true, // 显示播放的控件
                sources: [
                    // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
                    {
                        src: nowPlayVideoUrl,
                        type: "application/x-mpegURL" // 告诉videojs,这是一个hls流
                    }
                ]
            };
            // videojs的第一个参数表示的是，文档中video的id
            this.myPlyer = videojs("videoPlayer", this.options, function onPlayerReady() {
            });
        },
        // 控制顶部导航栏的定位
        handleScroll() {
            let tops = this.$refs.targetElement?this.$refs.targetElement.offsetTop - 60:0;
            let scrollY = window.scrollY; //获取滚动后的高度
            console.log('scrollY', scrollY, tops)
            if (scrollY >= tops) {

                this.showTop = true;

            }

            else {
                this.showTop = false;
                // this.activeIndex = null;
                this.activeIndex = "";
            }
        },
        // 下载报告书
        downloadReport() {
            window.open(
                "https://oss.0790jiaxiao.com/Report/SpingSummerInvestment2023032801.pdf"
            );
        },
        // 获取老师直播回放
        async playBack() {
            const data = {
                platid: 1,
                sort: "ut,DESC",
                type: 0,
                page: 0,
                size: 10,
            };
            await this.$store.dispatch("home/getPlayBack", data);
        },
        // 跳转视频回放
        goVideo(attr) {
            // console.log(this.teacherPlayBack);
            switch (attr) {
                case 0:
                    window.open(this.teacherPlayBack[4].fpath);
                    break;
                case 1:
                    window.open(this.teacherPlayBack[3].fpath);
                    break;
                case 2:
                    window.open(this.teacherPlayBack[2].fpath);
                    break;
                case 3:
                    window.open(this.teacherPlayBack[1].fpath);
                    break;
                case 4:
                    window.open(this.teacherPlayBack[0].fpath);
                    break;
                default:
                    break;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.heads {
    width: 100%;
    height: 100px;
    background: #070507;
    padding: 30px 200px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;

    img {
        height: 50px;
        margin-right: 171px;
    }

    .headlist {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #ffffff;

        .head-name {

            cursor: pointer;
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .head-line {
            width: 40px;
            height: 4px;
            background: #f00000;
            margin-top: 10px;
        }
    }

    .el-menu-demo {
        background: #070507;
    }
}

.heads1 {
    background: rgba(7, 5, 7, 0);

    /deep/ .el-menu--horizontal>.el-menu-item {
        color: #000 !important;
    }
}

.float {
    position: fixed;
    top: 30%;
    right: 20px;
    z-index: 9;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    &-img {
        width: 147px;
        height: 177px;
        box-shadow: 7.22px 9.58px 18px 12px rgba(0, 33, 135, 0.10);
    }

    .close {
        width: 36px;
        height: 36px;
        margin-top: 22px;
        // box-shadow: 7.22px 9.58px 18px 12px rgba(0, 33, 135, 0.10);
    }
}

.float1 {
    position: fixed;
    top: 82%;
    right: 0px;
    z-index: 9;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    img {
        width: 71px;
        height: 71px;

    }
}

.box {
    // width: 100%;
    height: auto;
    max-width: 1920px;
    min-width: 1640px;

    .bannerBox {
        width: 100%;
        position: relative;

        .banner {
            width: 100%;
            display: block;
        }

        .top-title1 {
            position: absolute;
            top: 20%;
            left: 21%;

            height: 398px;
        }

        .top-title {
            position: absolute;
            top: 60%;
            left: 40%;
            cursor: pointer;
            height: 192px;
        }

        .top-slider {
            position: absolute;
            top: 80%;
            left: 30%;

            span {
                color: #fff;
                font-size: 36px;
            }

            .day {
                position: absolute;
                left: 41%;
                top: 29%;
            }

            .hours {
                position: absolute;
                left: 56%;
                top: 29%;
            }

            .minute {
                position: absolute;
                left: 72%;
                top: 29%;
            }

            .second {
                position: absolute;
                left: 87%;
                top: 29%;
            }
        }

        .logo {
            position: absolute;
            top: 30px;
            left: 50px;
            cursor: pointer;
        }

        &-area {
            position: absolute;
            top: 45%;
            left: 8%;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        &-top {
            width: 318px;
            height: 47px;
            background: #ffffff;
            box-shadow: -2px 0px 32px 2px rgba(0, 33, 135, 0.04);
            font-size: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            text-align: center;
            line-height: 47px;
            color: #ea3231;

            img {
                width: 14px;
                height: 16px;
                margin-left: 13px;
            }
        }

        &-tit {
            color: #000;
            margin-top: 20px;
        }
    }

    .content {
        width: 100%;
        height: 7130px;
        // background: url('/subject/newReport/background.png') no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 40px 0;
        margin-bottom: 16%;

        .part1 {
            background: url('/subject/opportunity/bg.png') no-repeat;
            background-size: 100% 100%;
            padding: 51px 0 73pz;

            &-box {
                width: 1400px;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            &-box1 {
                margin-top: 160px;
            }

            &-top {
                width: 447px;
                height: 149px;
                margin-bottom: 60px;
            }

            &-cont {
                height: 586px;
                display: flex;
                width: 100%;

            }

            &-video {
                width: 1010px;
                height: 586px;
            }

            &-label {

                font-size: 12px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;

                text-align: center;
                color: #b3b3b3;
                margin: 26px 0 56px;
            }

            &-right {
                padding: 20px 28px 0;
                background: #fff;
                flex: 1;
                box-sizing: border-box;
                height: 586px;
                overflow: hidden;
                overflow-y: scroll;
                /* 隐藏滚动条 */
                scrollbar-width: none;
                /* Firefox */
                -ms-overflow-style: none;
                /* IE and Edge */

                &::-webkit-scrollbar {
                    display: none;
                    /* Chrome, Safari, Opera */
                }

                p {
                    font-size: 24px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    text-align: left;
                    color: #000000;
                    margin-bottom: 20px;
                }

                .video-box {
                    width: 334px;
                    height: 98px;
                    background: url('/subject/opportunity/bgs.png') no-repeat;
                    background-size: 100% 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 26px 0 16px;
                    box-sizing: border-box;
                    margin-bottom: 12px;

                    img {
                        width: 40px;
                        height: 40px;
                    }

                }

                .videobox1 {
                    background: url('/subject/opportunity/active.png') no-repeat;
                    background-size: 100% 100%;

                }

                .videobox2 {
                    background: url('/subject/opportunity/active1.png') no-repeat;
                    background-size: 100% 100%;

                }

                .video-tit {
                    color: #fff;
                    text-align: left;

                    .tits {
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;

                    }

                    .tits1(2) {
                        font-size: 14px;
                        margin-top: 10px;
                    }
                }
            }

            .p2-flex {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 37px;
            }

            .p2-flexs {
                display: flex;
                align-items: center;
            }

            .icon1 {
                background: url('/subject/opportunity/icons.png') no-repeat;

            }

            .icon2 {
                background: url('/subject/opportunity/icon1s.png') no-repeat;

            }

            .icon3 {
                background: url('/subject/opportunity/icon2s.png') no-repeat;

            }

            .icon4 {
                background: url('/subject/opportunity/icon3s.png') no-repeat;

            }

            .p2-box {



                background-size: 100% 100%;
                width: 584px;
                height: 454px;
                box-shadow: -2px 0px 32px 2px rgba(0, 33, 135, 0.04);
                position: relative;



                .conts {
                    display: flex;
                    flex-direction: column;
                    box-sizing: border-box;
                    position: absolute;
                    top: 94px;
                    right: 36px;
                    width: 285px
                }


                .tops {
                    display: flex;
                    align-items: center;

                    span {
                        font-size: 16px;

                        font-weight: 700;
                        text-align: left;
                        color: #f00000;
                        margin-left: 6px;
                    }
                }

                .tit {
                    margin: 12px 0 20px 0;
                    font-size: 14px;
                    text-align: left;
                    color: #f00000;
                    width: 285px;
                }

                .introduce {
                    font-weight: 700;
                    text-align: left;
                    color: #1a1a1a;
                }

                .bott {
                    width: 285px;
                    height: 222px;
                    font-size: 14px;
                    box-sizing: border-box;
                    text-align: left;
                    color: #999999;
                    line-height: 22px;
                }
            }

            .p2-content {
                margin-top: 26px;
                text-align: center;
                //  width: 449px;
                height: 13px;
                font-size: 12px;

                font-weight: 400;
                text-align: center;
                color: #cccccc;
            }

            .teachericon {
                width: 256px;
                height: 454px;
            }
        }

        .flex {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .part {
            // width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            position: relative;

            p {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                bottom: 3.5%;
                left: 0;
                box-sizing: border-box;

                img {
                    width: 350px;
                    margin: 0 30px;
                    cursor: pointer;
                }
            }

            .live800text {
                width: 268px;
                position: absolute;
                bottom: 1%;
                left: 32%;
            }
        }





        .partcont1 {
            background: url("/subject/opportunity/bg1.png") no-repeat;
            background-size: 100% 100%;
        }

        .part3 {
            &-content {
                width: 1400px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                flex-direction: column;
                padding-top: 160px;
            }

            .topbg {
                width: 298px;
                height: 149px;
                margin-bottom: 60px;
            }

            p {
                bottom: 6%;
            }

            .live800text {
                bottom: 2.2%;
            }

            .p1_box {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                position: relative;

                .p1-left {
                    display: flex;
                    flex-direction: column;

                }

                .p1-right {
                    .boxs {
                        width: 1030px;
                        height: auto;
                        background: rgba(255, 255, 255, 0.60);
                        box-shadow: -2px 0px 32px 2px rgba(0, 33, 135, 0.04), 0px 0px 0.8px 0px #ffffff inset;
                        font-size: 18px;
                        padding: 30px 0 30px 47px;
                        font-weight: 700;
                        text-align: left;
                        color: #000000;
                        line-height: 36px;
                        display: flex;

                        margin-bottom: 26px;
                    }

                    .boxs1 {
                        background: url("/subject/opportunity/bg4.png") no-repeat;
                        background-size: calc(100% + 47px) calc(100% + 30px);
                        /* 宽度加上左侧padding */
                        background-position: center center;
                        color: #fff;

                        .name {
                            color: #fff;
                        }
                    }

                    .title {
                        width: 265px;

                        font-size: 20px;
                        line-height: 30px;
                        margin: 0 206px 0 127px;
                    }

                    .avatar {
                        width: 50px;
                        height: 50px;
                        margin-right: 20px;
                    }

                    .name {
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 22px;
                    }

                    .introduce {
                        display: flex;

                        p {
                            display: flex;
                            flex-direction: column;
                        }
                    }

                }


                .p1-left img:nth-child(1) {
                    width: 247px;
                    height: 112px;
                }

                .p1-img {
                    width: 196px;
                    height: 46px;
                    margin: 20px 0;
                    cursor: pointer;
                }

                .p1-img1 {
                    width: 196px;
                    height: 46px;
                    cursor: pointer;
                }

                .p1-content {
                    width: 271px;
                    height: auto;
                    font-size: 18px;
                    margin-bottom: 60px;
                    font-weight: 700;
                    text-align: left;
                    color: #000;
                    display: flex;
                    flex-direction: column;

                    .weight {
                        color: #f00000;
                    }

                    line-height: 36px;

                    .year {
                        font-size: 30px;
                        font-family: Bebas Neue, Bebas Neue-Bold;
                    }

                    .date {
                        font-family: Bebas Neue, Bebas Neue-Bold;
                        font-size: 60px;
                        background: linear-gradient(to right, #002471 0%, #085ed1 100%);
                        /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
                        -webkit-background-clip: text;
                        /*将设置的背景颜色限制在文字中*/
                        -webkit-text-fill-color: transparent;
                        margin: 20px 0 60px;
                        line-height: 60px;

                    }

                    .tips {
                        font-size: 12px;

                        color: #b3b3b3;
                        margin-top: 10px;
                    }
                }

                .p1-content1 {
                    width: 235px;
                    width: 180px;
                    height: 13px;
                    font-size: 12px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;

                    span {
                        color: #f00000;
                        font-weight: 600;
                    }
                }
            }
        }

        .part4 {


            padding-top: 150px;

            &-cont {
                width: 1400px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                flex-direction: column;

            }

            .toptit {
                width: 446px;
                height: 149px;
                margin-bottom: 60px;
            }

            .p1_box {
                // width: 100%;
                // height: 968px;
                margin-top: 37px;
                // padding: 0 300px 160px;
                display: flex;
                justify-content: space-between;

                position: relative;
                width: 100%;
                padding: 60px 50px;
                box-sizing: border-box;
                height: 566px;
                background: rgba(255, 255, 255, 0.60);
                box-shadow: -2px 0px 32px 2px rgba(0, 33, 135, 0.04), 0px 0px 0.8px 0px #ffffff inset;

                .p1-left {
                    display: flex;
                    flex-direction: column;

                }

                .p1-right {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;

                    img {
                        width: 316px;
                        height: 446px;
                        margin-right: 20px;

                    }

                    .starttime {
                        position: absolute;
                        right: 26px;
                        bottom: 17px;
                        width: 105px;
                        height: 13px;
                        font-size: 12px;

                        font-weight: 400;
                        text-align: right;
                        color: #000;
                        letter-spacing: 0.6px;
                    }
                }

                .p1-left img:nth-child(1) {
                    width: 247px;
                    height: 112px;
                }

                .p1-img {
                    width: 196px;
                    height: 46px;
                    margin: 20px 0;
                    cursor: pointer;
                }

                .p1-img1 {
                    width: 196px;
                    height: 46px;
                    cursor: pointer;
                }

                .p-content {
                    font-size: 18px;

                    font-weight: 700;
                    text-align: left;
                    color: #ea3130;
                    line-height: 30px;

                }

                .p1-content {
                    width: 234px;
                    font-size: 18px;

                    font-weight: 700;
                    text-align: left;
                    color: #000000;
                    line-height: 30px;
                }

                .p1-content2 {
                    width: 235px;

                    font-size: 22px;
                    margin: 22px 0 33px 0;
                    font-weight: 700;
                    text-align: left;
                    color: #000;

                    span {
                        color: #f00000;
                    }

                    line-height: 36px;
                }

                .p1-content1 {
                    width: 235px;
                    width: 180px;
                    height: 13px;
                    font-size: 12px;

                    font-weight: 400;
                    text-align: left;
                    color: #000;

                    span {
                        color: #f00000;
                        font-weight: 600;
                    }
                }
            }

            .part4box {
                width: 100%;
                height: 1735px;
                background: url("/subject/newReport/p4Banner.png") no-repeat;
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: flex-start;
            }

            p {
                bottom: 3%;
            }

            .download {
                position: absolute;
                cursor: pointer;
                top: 25%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .partcont {
            background: url("/subject/opportunity/bg2.png") no-repeat;
            background-size: 100% 100%;

        }

        .part6 {

            padding-top: 160px;

            &-content {
                width: 1400px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                flex-direction: column;
            }

            &-tit {
                width: 446px;
                height: 149px;
                margin-bottom: 60px;
            }

            .historyItem {
                cursor: pointer;
                width: 100%;
                height: 326px;
                background: rgba(255, 255, 255, 0.60);
                box-shadow: -2px 0px 32px 2px rgba(0, 33, 135, 0.04), 0px 0px 0.8px 0px #ffffff inset;
                display: flex;
                padding: 40px 50px;
                box-sizing: border-box;
                margin-bottom: 26px;

                .historybg {
                    width: 686px;
                    height: 246px;
                    margin-right: 60px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .rightcont {
                margin-top: 15px;
                text-align: left;
                color: #000000;
                line-height: 30px;
                font-size: 16px;

                .title {
                    font-size: 26px;

                    font-weight: 700;

                }

                .cont {
                    margin: 16px 0 40px;
                    line-height: 26px;
                }

                .time {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #b2b2b2;
                    width: 211px;
                    height: 30px;
                    margin-bottom: 10px;

                    background: rgba(0, 0, 0, 0.02);

                    img {
                        width: 14px;
                        height: 14px;
                        margin-right: 10px;
                    }


                }

                .detail {
                    cursor: pointer;
                    color: #ea3130;

                }
            }
        }

        .part7 {
            margin-top: 160px;

            &-content {
                width: 1400px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                flex-direction: column;

                .media {
                    width: 100%;
                    height: 532px;
                }
            }

            &-tit {
                width: 446px;
                height: 149px;
                margin-bottom: 60px;
            }
        }

        .part8 {

            background: url("/subject/opportunity/bg3.png") no-repeat;
            background-size: 100% 100%;
            padding: 84px 0 200px;


            &-content {
                display: flex;
                align-items: center;
                flex-direction: column;
                width: 1400px;
                margin: 0 auto;

                .topbg {
                    width: 194px;
                    height: 149px;
                    margin-bottom: 60px;
                }

                .phoneBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .phone {
                    width: 622px;
                    height: 708px;
                }

                .partRight {
                    display: inline-block;
                    margin-bottom: 10%;

                    .advantage {
                        margin-bottom: 32px;
                    }

                    // margin-left: 500px;

                    .ewm {
                        width: 258px;
                        height: 258px;
                        margin: 0 auto;
                    }
                }

                ul {
                    li {
                        width: 356px;
                        height: 74px;
                        text-align: center;
                        line-height: 74px;
                        color: #e4760b;
                        font-size: 26px;
                        margin-bottom: 35px;
                        margin-left: 40px;
                        font-weight: bold;
                        border: 1px solid #e4760b;
                        border-radius: 10px;
                        display: inline-block;
                    }
                }

                .appCode {
                    display: flex;
                    // justify-content: center;
                    flex-direction: column;
                    text-align: center;

                    width: 615px;

                    .app-box {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    // height: 302px;

                    .appcode-title {
                        font-size: 14px;

                        font-weight: 400;
                        text-align: center;
                        color: #ff3333;
                        line-height: 28px;
                        margin-bottom: 13px;
                    }

                    .codeBody {
                        >div:first-child {
                            font-weight: 700;
                            margin-bottom: 20px;
                            // font-size: 20px;
                            color: #000;
                        }

                        .codeBox {
                            display: flex;
                            justify-content: center;
                            margin-bottom: 15px;
                            margin-right: 30px;

                            .codeItem {
                                &:first-child {
                                    margin-right: 15px;
                                }

                                .canvasCode {
                                    border-radius: 6px;
                                }

                                div {
                                    line-height: 32px;
                                    // line-height: 48px;
                                    // background: #e4760b;
                                    background: linear-gradient(150deg, #ff2c41 0%, #ff1232 100%),
                                        #ff3333;
                                    color: #fff;
                                    border-radius: 4px;
                                    margin-top: 6px;
                                    // font-size: 20px;
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }

                .serveBox {
                    // background: #fff;
                    margin-left: 14px;
                    width: 569px;
                    height: 68px;

                    &-serve {
                        color: red;
                        border-bottom: 1px solid red;
                        cursor: pointer;
                    }

                    &-item {
                        div {
                            text-align: left;
                            margin: 0;
                            line-height: normal;
                            // font-size: 16px;
                            // color: #2d2d2d;
                            font-size: 14px;
                            color: #000;
                            text-indent: 1.5em;

                            /* 设置整体缩进 */
                            &:first-child {
                                text-indent: 0;
                            }
                        }
                    }

                    &-title {
                        color: #000;
                        margin-top: 16px;

                        div {
                            text-align: left;
                            margin: 0;
                            line-height: normal;

                            font-size: 16px;
                            color: #ff3333;
                            // text-indent: 1.5em; /* 设置整体缩进 */
                            font-size: 16px;

                            font-weight: 700;

                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }
}

/deep/ .videoPlayer-dimensions {
    width: 1010px;
    height: 586px;
}

.header-title {
    color: #fff;
}

/deep/ .el-menu--horizontal {
    // background-color: #070507;
}

/deep/ .el-menu--horizontal>.el-menu-item {
    color: #fff;
}

/deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    // background-color: #070507;
    background: rgba(7, 5, 7, 0);
}
</style>